import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const FilterSelect = ({ label, value, onChange, options, testId, allLabel }) => (
  <div className="grid gap-1.5 min-w-[160px]">
    <Label className="text-xs text-slate-500">{label}</Label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent>
        {allLabel && <SelectItem value="all">{allLabel}</SelectItem>}
        {options.map(o => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);

export const DateRange = ({ from, to, setFrom, setTo, prefix }) => (
  <>
    <div className="grid gap-1.5">
      <Label className="text-xs text-slate-500">From</Label>
      <Input type="date" value={from} onChange={e => setFrom(e.target.value)} className="w-40" data-testid={`${prefix}-from-date`} />
    </div>
    <div className="grid gap-1.5">
      <Label className="text-xs text-slate-500">To</Label>
      <Input type="date" value={to} onChange={e => setTo(e.target.value)} className="w-40" data-testid={`${prefix}-to-date`} />
    </div>
  </>
);

export const ViewSwitch = ({ options, value, onChange, prefix }) => (
  <div className="flex flex-wrap gap-2" data-testid={`${prefix}-view-switch`}>
    {options.map(o => (
      <button
        key={o.value}
        type="button"
        onClick={() => onChange(o.value)}
        data-testid={`${prefix}-view-${o.value}`}
        className={`px-3 py-1.5 rounded-full text-sm border transition-colors duration-150 ${value === o.value ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-slate-700 border-slate-200 hover:border-blue-300 hover:bg-blue-50'}`}
      >
        {o.label}
      </button>
    ))}
  </div>
);
